import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect} from "@angular/material/select";
import {FormsModule} from "@angular/forms";

import {SelectionItem} from "../../selections/selection-item";
import {SelectionService} from "../../services/selection-service";
import {StringUtils} from "../../utils/string-utils";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-state-selection-dialog',
    imports: [
    MatButton,
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatLabel
],
    templateUrl: './state-selection-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './state-selection-dialog.component.css'
})
export class StateSelectionDialogComponent implements OnInit {
  private readonly selectionService = inject(SelectionService);
  private readonly dialogRef = inject<MatDialogRef<StateSelectionDialogComponent>>(MatDialogRef);


  selectedStateCode!: string;
  readonly states = signal<SelectionItem[]>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);
  errorMessage!: string;

  ngOnInit(): void {
    this.isBusy.set(true);
    this.selectionService.getStateCodes().subscribe({
      next: (states: SelectionItem[]) => {
        this.states.set(states);
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage = StringUtils.getErrorMessage(error);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  invalidSelection(): boolean {
    return StringUtils.isBlank(this.selectedStateCode);
  }

  saveAndClose(): void {
    if (!this.invalidSelection()) {
      this.dialogRef.close(this.selectedStateCode);
    }
  }

}
